export const allRights: any = {
  common: {
    access_tracks: {
      title: 'Построение треков',
      value: 1,
      safe: true,
      depends: [],
    },
    access_reports: {
      title: 'Построение отчетов',
      value: 2,
      safe: true,
      depends: [],
    },
    access_create_report_templates: {
      title: 'Создание шаблона отчета',
      value: 4,
      safe: false,
      depends: ['Access.common.access_reports'],
    },
    access_messages: {
      title: 'Просмотр сообщений',
      value: 8,
      safe: true,
      depends: [],
    },
    access_notifications: {
      title: 'Просмотр уведомлений',
      value: 16,
      safe: true,
      depends: [],
    },
    access_notifications_management: {
      title: 'Создание, изменение, удаление уведомлений',
      value: 32,
      safe: false,
      depends: ['Access.common.access_notifications'],
    },
    access_geozones: {
      title: 'Просмотр геозон',
      value: 64,
      safe: true,
      depends: [],
    },
    access_geozones_management: {
      title: 'Создание, изменение, удаление геозон',
      value: 128,
      safe: false,
      depends: ['Access.common.access_geozones'],
    },
    access_drivers: {
      title: 'Просмотр водителей',
      value: 256,
      safe: true,
      depends: [],
    },
    access_drivers_management: {
      title: 'Создание, изменение, удаление водителей',
      value: 512,
      safe: false,
      depends: ['Access.common.access_drivers'],
    },
    access_drivers_assign: {
      title: 'Назначение водителей',
      value: 1024,
      safe: false,
      depends: ['Access.common.access_drivers'],
    },
    access_trailers: {
      title: 'Просмотр прицепов',
      value: 2048,
      safe: true,
      depends: [],
    },
    access_trailers_management: {
      title: 'Создание, изменение, удаление прицепов',
      value: 4096,
      safe: false,
      depends: ['Access.common.access_trailers'],
    },
    access_trailers_assign: {
      title: 'Назначение прицепов',
      value: 8192,
      safe: false,
      depends: ['Access.common.access_trailers'],
    },
    access_objects_create: {
      title: 'Создание объекта',
      value: 16384,
      safe: false,
      depends: [],
    },
    access_objects_groups_management: {
      title: 'Создание групп объектов',
      value: 32768,
      safe: false,
      depends: [],
    },
    access_users_create: {
      title: 'Создание пользователей',
      value: 65536,
      safe: false,
      depends: [],
    },
    access_buildings: {
      title: 'Просмотр зданий',
      value: 131072,
      safe: true,
      depends: ['Access.common.access_devices'],
    },
    access_buildings_management: {
      title: 'Создание, изменение, удаление зданий',
      value: 262144,
      safe: false,
      depends: ['Access.common.access_buildings'],
    },
    access_devices: {
      title: 'Просмотр устройств',
      value: 524288,
      safe: true,
      depends: [],
    },
    access_devices_management: {
      title: 'Создание, изменение, удаление устройств',
      value: 1048576,
      safe: false,
      depends: ['Access.common.access_devices'],
    },
    access_locators: {
      title: 'Доступ к локатору',
      value: 2097152,
      safe: true,
      depends: [],
    },
    access_edit_credentials: {
      title: 'Изменение учётных данных',
      value: 4194304,
      safe: false,
      depends: [],
    },
    access_maintenance: {
      title: 'Доступ к разделу Техобслуживание',
      value: 8388608,
      safe: true,
      depends: [],
    },
    access_icon_library: {
      title: 'Manage icon library',
      value: 16777216,
      safe: false,
      depends: [],
    },
  },
  objects: {
    standard: {
      view: {
        title: 'Просмотр объекта и его основных свойств',
        value: 1,
        safe: true,
        depends: [],
      },
      view_detail: {
        title: 'Просмотр дополнительных свойств объекта',
        value: 2,
        safe: true,
        depends: ['Access.objects.standard.view'],
      },
      edit_detail: {
        title: 'Изменение дополнительных свойств объекта',
        value: 4,
        safe: false,
        depends: ['Access.objects.standard.view_detail'],
      },
      view_additional_fields: {
        title: 'Просмотр настраиваемых полей объекта',
        value: 8,
        safe: true,
        depends: ['Access.objects.standard.view'],
      },
      edit_additional_fields: {
        title: 'Изменение настраиваемых полей объекта',
        value: 16,
        safe: false,
        depends: ['Access.objects.standard.view', 'Access.objects.standard.view_additional_fields'],
      },
      edit_other_properties: {
        title: 'Изменение неупомянутых свойств объекта',
        value: 32,
        safe: false,
        depends: ['Access.objects.standard.view'],
      },
      change_icon: {
        title: 'Изменение иконки',
        value: 64,
        safe: false,
        depends: ['Access.objects.standard.view'],
      },
      rename: {
        title: 'Переименование объекта',
        value: 128,
        safe: false,
        depends: ['Access.objects.standard.view'],
      },
      delete: {
        title: 'Удаление объекта',
        value: 256,
        safe: false,
        depends: ['Access.objects.standard.view'],
      },
      access_control: {
        title: 'Настройка прав доступа к объекту',
        value: 512,
        safe: false,
        depends: ['Access.objects.standard.view'],
      },
      reports_and_messages: {
        title: 'Запрос сообщений, отчетов, треков, событий',
        value: 1024,
        safe: true,
        depends: ['Access.objects.standard.view'],
      },
      view_maintenance: {
        title: '"View maintenance intervals"',
        value: 4194304,
        safe: true,
        depends: ['Access.objects.standard.view'],
      },
      manage_maintenance: {
        title: 'Manage maintenance intervals',
        value: 8388608,
        safe: false,
        depends: ['Access.objects.standard.view', 'Access.objects.standard.view_maintenance'],
      },
    },
    special: {
      view_connection_settings: {
        title: 'Просмотр настроек подключения',
        value: 2048,
        safe: true,
        depends: ['Access.objects.standard.view'],
      },
      edit_connection_settings: {
        title: 'Изменение настроек подключения',
        value: 4096,
        safe: false,
        depends: [
          'Access.objects.standard.view',
          'Access.objects.special.view_connection_settings',
        ],
      },
      management_sensors: {
        title: 'Создание, изменение, удаление датчиков',
        value: 8192,
        safe: false,
        depends: ['Access.objects.standard.view'],
      },
      view_command: {
        title: 'Просмотр команд',
        value: 16384,
        safe: true,
        depends: ['Access.objects.standard.view'],
      },
      send_command: {
        title: 'Отправка команд',
        value: 32768,
        safe: false,
        depends: ['Access.objects.special.view_command'],
      },
      management_command: {
        title: 'Создание, изменение, удаление команд',
        value: 65536,
        safe: false,
        depends: [
          'Access.objects.standard.view',
          'Access.objects.special.view_command',
          'Access.objects.special.view_connection_settings',
        ],
      },
      change_trip_detector: {
        title: 'Изменение детектора поездок',
        value: 131072,
        safe: false,
        depends: ['Access.objects.standard.view', 'Access.objects.standard.view_detail'],
      },
      using_object: {
        title: 'Использование объекта в уведомлениях',
        value: 262144,
        safe: false,
        depends: ['Access.objects.standard.view'],
      },
      view_msg_filter: {
        title: 'Просмотр настроек фильтрации валидности сообщений',
        value: 524288,
        safe: true,
        depends: ['Access.objects.standard.view'],
      },
      edit_msg_filter: {
        title: 'Изменение настроек фильтрации валидности сообщений',
        value: 1048576,
        safe: false,
        depends: ['Access.objects.special.view_msg_filter'],
      },
      management_event: {
        title: 'Управление событиями',
        value: 2097152,
        safe: false,
        depends: ['Access.objects.standard.reports_and_messages'],
      },
      delete_messages: {
        title: 'Удаление сообщений',
        value: 16777216,
        safe: false,
        depends: ['Access.objects.standard.reports_and_messages'],
      },
    },
  },
  object_groups: {
    standard: {
      view: {
        title: 'Просмотр группы объектов и её основных свойств',
        value: 1,
        safe: true,
        depends: [],
      },
      edit: {
        title: 'Редактирование группы объектов',
        value: 2,
        safe: false,
        depends: ['Access.object_groups.standard.view'],
      },
      delete: {
        title: 'Удаление группы объектов',
        value: 4,
        safe: false,
        depends: ['Access.object_groups.standard.view'],
      },
    },
    special: {},
  },
  users: {
    standard: {
      view: {
        title: 'Просмотр пользователя и его свойств',
        value: 1,
        safe: true,
        depends: [],
      },
      edit: {
        title: 'Изменение свойств пользователя',
        value: 2,
        safe: false,
        depends: ['Access.users.standard.view'],
      },
      delete: {
        title: 'Удаление пользователя',
        value: 4,
        safe: false,
        depends: ['Access.users.standard.view'],
      },
    },
    special: {
      access: {
        title: 'Настройка прав доступа пользователя',
        value: 8,
        safe: false,
        depends: ['Access.users.standard.edit'],
      },
    },
  },
  report_templates: {
    standard: {
      view: {
        title: 'Просмотр шаблона отчета',
        value: 1,
        safe: true,
        depends: [],
      },
      edit: {
        title: 'Изменение шаблона отчета',
        value: 2,
        safe: false,
        depends: ['Access.report_templates.standard.view'],
      },
      delete: {
        title: 'Удаление шаблона отчета',
        value: 4,
        safe: false,
        depends: ['Access.report_templates.standard.view'],
      },
    },
    special: {},
  },
};
